import {NgModule} from '@angular/core';
import {RouterModule, Routes} from '@angular/router';
import {ClientDetailComponent} from './client-detail/client-detail.component';
import {ClientListComponent} from './client-list/client-list.component';
import {HomeComponent} from './home/home.component';
import {NewClientComponent} from './new-client/new-client.component';
import {ClientProgressComponent} from './client-detail/client-progress/client-progress.component';
import {ClientEditComponent} from './client-detail/client-edit/client-edit.component';
import {BuddyPageComponent} from './buddy-page/buddy-page.component';
import {InstructionsComponent} from './instructions/instructions.component';
import {RegisterComponent} from './register/register.component';
import {QuestionnaireListComponent} from './questionnaire-list/questionnaire-list.component';
import {NewQuestionnaireComponent} from './questionnaire-list/new-questionnaire/new-questionnaire.component';
import {TenantListComponent} from './tenant-list/tenant-list.component';
import {TenantDetailComponent} from './tenant-list/tenant-detail/tenant-detail.component';
import {CoachEditComponent} from './tenant-list/tenant-detail/coach-edit/coach-edit.component';
import {NewCoachComponent} from './tenant-list/tenant-detail/new-coach/new-coach.component';
import {ClientChatComponent} from './client-detail/client-chat/client-chat.component';

const routes: Routes = [
  {
    path: 'dashboard',
    component: HomeComponent,
    children: [
      {path: 'chat', component: BuddyPageComponent},
      {path: 'clients', component: ClientListComponent},
      {path: 'instructions', component: InstructionsComponent},
      {path: 'questionnaires', component: QuestionnaireListComponent},
      {path: 'questionnaires/new', component: NewQuestionnaireComponent},
      {path: 'tenants', component: TenantListComponent},
      {path: 'tenants/:id', component: TenantDetailComponent},
      {path: 'tenants/:id/coach/:coachId', component: CoachEditComponent},
      {path: 'tenants/:id/new-coach', component: NewCoachComponent},
      {path: 'clients/new', component: NewClientComponent},
      {
        path: 'clients/:id',
        component: ClientDetailComponent,
        children: [
          {path: '', redirectTo: 'overview', pathMatch: 'full'},
          {path: 'overview', component: ClientProgressComponent},
          {path: 'edit', component: ClientEditComponent},
          {path: 'chat', component: ClientChatComponent},
        ],
      },
    ],
  },
  {path: 'register/:uuid', component: RegisterComponent},
  {path: '', redirectTo: 'dashboard/clients', pathMatch: 'full'},
  {path: '**', redirectTo: 'dashboard/clients'},
];

@NgModule({
  imports: [RouterModule.forRoot(routes)],
  exports: [RouterModule],
})
export class AppRoutingModule {}
